import * as taskName from './task-name'
import * as processUI from '../../process-ui'
import { createUIDefinition } from '../default-task-definition'

export default createUIDefinition({
    taskName: taskName.CLARIFY_ALIGNER_CHECKIN_COMMENT,
    widgetList: [
        {
            component: processUI.TREATMENT_FEEDBACK_WIDGET,
        },
    ],
})



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/treatment/clarify-aligner-checkin-comment.js